export default __webpack_public_path__ + "static/media/Flare3.5f685894.png";